var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "footer has-shadow" }, [
    _c("div", { staticClass: "content has-text-centered" }, [
      _c(
        "p",
        [
          [
            _vm._v(
              "Copyright © " +
                _vm._s(_vm.$dayjs().format("YYYY")) +
                " Designed by"
            ),
          ],
          _vm._m(0),
          _vm._v(". "),
          [_vm._v("All rights reserved.")],
          _c(
            "i",
            {
              staticClass: "is-pulled-right",
              staticStyle: { "font-size": "0.7rem" },
            },
            [_vm._v(" v" + _vm._s(_vm.appVersion) + " ")]
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "http://fr-gps.com", target: "_blank" } }, [
      _c("span", { staticClass: "has-text-primary has-text-weight-bold" }, [
        _vm._v(" Gps "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }